import { ChatService } from './chat.service';

export default angular
  .module('sfMobile.services.chatApi', ['sfMobile.services.api-url'])
  .factory('chatApiService', ChatService).name;
